<script setup lang="ts">

</script>

<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100" fill="none">
        <path d="M0 48C0 25.3726 0 14.0589 7.02944 7.02944C14.0589 0 25.3726 0 48 0H52C74.6274 0 85.9411 0 92.9706 7.02944C100 14.0589 100 25.3726 100 48V52C100 74.6274 100 85.9411 92.9706 92.9706C85.9411 100 74.6274 100 52 100H48C25.3726 100 14.0589 100 7.02944 92.9706C0 85.9411 0 74.6274 0 52V48Z" fill="#0077FF"/>
        <path d="M82 50C82 67.6731 67.6731 82 50 82C32.3269 82 18 67.6731 18 50C18 32.3269 32.3269 18 50 18C67.6731 18 82 32.3269 82 50Z" fill="#00D3E6"/>
        <path d="M89.2569 27.7792C91.687 25.3491 90.1236 21.1882 86.6945 20.9596L79.4152 20.5318L79.1059 13.3709C78.8773 9.94192 74.7164 8.37852 72.2863 10.8086L62.9058 20.1891C61.8254 21.2695 61.2983 22.7845 61.4748 24.3022L62.2533 30.9973L54.4171 38.8336C53.0473 38.2896 51.5537 37.9906 49.9902 37.9906C43.3628 37.9906 37.9902 43.3632 37.9902 49.9906C37.9902 56.618 43.3628 61.9906 49.9902 61.9906C56.6177 61.9906 61.9902 56.618 61.9902 49.9906C61.9902 48.6143 61.7585 47.292 61.332 46.0608L69.3244 38.0684L75.7633 38.5907C77.281 38.7672 78.796 38.2401 79.8764 37.1597L89.2569 27.7792Z" fill="white"/>
    </svg>
</template>

<style scoped>

</style>